export enum ScanStatus {
  Done = 'done',
  Pending = 'pending',
  Failed = 'failed',
}
